import React, { useEffect } from "react";
import OrderList from "../../components/admin/OrderList";


const OrderListPage = () => {

    useEffect(() => {
        document.body.id = "order-list-002";
      }, []);

  return (
    <div>
   <OrderList />
    </div>
  );
};

export default OrderListPage;
